import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import SellyoMembersTable from "../../../components/apps/sellyo-members/SellyoMembersTable";
import { useNavigate } from "react-router";

export default function SellyoMembersPage() {
    const navigate = useNavigate();

    return (
        <>
            <PageMeta
                title="Sellyo - Sellyo Members"
                description="Sellyo Members"
            />
            <PageBreadcrumb
                pageTitle="Sellyo Members"
                showBackButton={true}
                onBack={() => navigate("/apps")}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <SellyoMembersTable />
                </div>
            </div>
        </>
    );
}